'use strict';

import {wpModel} from "../../models/wpmodel.js";
import {wpDeliverableModel} from '../../models/wpdeliverablemodel.js';

export class ProjectsIndicatorsCtrl
{
	data = [];
	$filter;
	$mdDialog;
	jsDataService;
	saveUrl = '';
	
	constructor($scope, $filter, $mdDialog, jsDataService){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.$mdDialog = $mdDialog;
		this.jsDataService = jsDataService;
		this.saveUrl = this.jsDataService.get('cfgSaveUrl', '');
		this.setData(this.jsDataService.get('deliverables', []));
	}
	
	setData(data){
		this.data = [];
		for(let wp of data){
			this.data.push(new wpModel(wp, this.$filter, this.jsDataService));
			if(typeof(wp.deliverables) !== 'undefined'){
				for(let dlvr in wp.deliverables){
					wp.deliverables[dlvr] = (new wpDeliverableModel(wp.deliverables[dlvr], this.$filter, this.jsDataService));
				}
			}
			else{
				wp.deliverables = [];
			}
		}
	}
	
	assignIndicator(ev, deliverable){
		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', "jsDataService", "deliverable", this.dialogCtrl],
			controllerAs: 'ctrl',
			templateUrl: 'projects/ng_indicator_assign.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: true,
			fullscreen: true,
			locals: {
				deliverable: angular.copy(deliverable),
			}
		}).then((results) => {
			if(this.saveUrl !== ''){
				this.$scope.basicHttpConfigProcess({
					url: this.saveUrl,
					method: 'POST',
					data: results.getData(),
				}).then((response) => {
					if(response.data.success && typeof(response.data.deliverable) !== 'undefined'){
						deliverable = angular.merge(deliverable, response.data.deliverable);
					}
				}, () => {});
			}
		}, (results) => {
			console.log(results);
		});
	}
	
	dialogCtrl($scope, $mdDialog, jsDataService, deliverable){
		$scope.classif = jsDataService.get('cfgClassif', {});
		$scope.deliverable = deliverable;
		$scope.close = function() {
			$mdDialog.cancel();
		};
		$scope.save = function() {
			$mdDialog.hide($scope.deliverable);
		};
	}
	
}